import type { ReceiptTemplate } from '../schema';

export const kohlsTemplate: ReceiptTemplate = {
  id: 'kohls',
  name: "Kohl's Receipt",
  brand: "KOHL'S",
  description: "Kohl's department store receipt",
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'kohls-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/kohls.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 22,
        addressLines: [
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'kohls-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans:', value: '847291' },
          { id: 'assoc', label: 'Assoc:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'kohls-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'CROFT & BARROW SHIRT', quantity: '1', price: '28.00', sku: '847291034' },
          { id: '2', name: 'APT 9 PANTS', quantity: '1', price: '44.00', sku: '847291035' },
          { id: '3', name: 'SONOMA SOCKS 6PK', quantity: '1', price: '12.00', sku: '847291036' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'kohls-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '84.00', isBold: false, isLarge: false },
          { id: 'kohls-cash', label: "KOHL'S CASH EARNED", value: '5.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '6.93', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '90.93', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'kohls-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: "KOHL'S CHARGE ****4144",
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'kohls-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: "YOU EARNED $5 KOHL'S CASH!\n\nReturns within 180 days\nTHANK YOU",
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

